<template lang="pug">
  .button-wrap
    ButtonItem(
      v-for="(button,index) in buttonList"
      v-bind="button"
      :key="button.name")
</template>

<script>
import ButtonItem from './ButtonItem.vue'
export default {
  name: 'buttonList',
  components: {
    ButtonItem
  },
  props: {
    buttonList: {
      type: Array,
      default: () => []
    } // 按钮组参数配置
  }
}
</script>
<style lang="sass" scoped>
.button-wrap
  .btn
    &:not(:last-child)
      margin-right: 8px
</style>



// WEBPACK FOOTER //
// index.vue?16471c36